import type {
  AnalyticsConfig,
  AnalyticsPageContext,
  AnalyticsProvider,
  AnalyticsTrackEvent,
} from './types';

export class Analytics {
  private providers: AnalyticsProvider[] = [];
  private configured = false;

  configure(config: AnalyticsConfig, providers: AnalyticsProvider[]): void {
    this.providers = providers;
    this.configured = true;
    void config;
  }

  isConfigured(): boolean {
    return this.configured;
  }

  page(ctx: AnalyticsPageContext): void {
    for (const provider of this.providers) {
      try {
        provider.page(ctx);
      } catch {
        // Analytics must never break the app.
      }
    }
  }

  track(event: AnalyticsTrackEvent): void {
    for (const provider of this.providers) {
      try {
        provider.track(event);
      } catch {
        // Analytics must never break the app.
      }
    }
  }
}

let singleton: Analytics | null = null;

export function getAnalytics(): Analytics {
  if (!singleton) {
    singleton = new Analytics();
  }
  return singleton;
}

/** @internal tests only */
export function resetAnalyticsForTests(): void {
  singleton = null;
}
